import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {FlowRestoreState} from '@fantasmagames/slot/src/modules/flow/states/FlowRestoreState';
import {FlowWhileSpinningState} from '@fantasmagames/slot/src/modules/flow/states/FlowWhileSpinningState';
import {GameFlowBasicState} from 'src/flow/states/GameFlowBasicState';
import {GameFlowFreeSpinsState} from 'src/flow/states/GameFlowFreeSpinsState';
import {GameFlowRespinState} from 'src/flow/states/GameFlowRespinState';
import {GameFlowAvalancheState} from 'src/flow/states/GameFlowAvalancheState';

export class GameFlowModule extends FlowModule {

	protected setupStates(): void {
		this.addState(new GameFlowBasicState(this, FlowModule.BASIC_STATE, this.eventManager));
		this.addState(new GameFlowFreeSpinsState(this, FlowModule.FREE_SPINS_STATE, this.eventManager));
		this.addState(new FlowRestoreState(this, FlowModule.RESTORE_STATE));
		this.addState(new GameFlowRespinState(this, FlowModule.RESPIN_STATE, this.eventManager));
		this.addState(new GameFlowAvalancheState(this, FlowModule.AVALANCHE_STATE, this.eventManager));
		this.addState(new FlowWhileSpinningState(this, FlowModule.WHILESPIN_STATE, this.eventManager));
	}
}



// WEBPACK FOOTER //
// ./src/flow/GameFlowModule.ts